import React from 'react';
import PropTypes from 'prop-types';
import { FaArrowLeft, FaTrophy } from 'react-icons/fa';

export const QuizHeader = ({ 
  title = 'Quiz',
  onBack, 
  currentQuestionIndex = 0, 
  totalQuestions = 0, 
  score = 0 
}) => (
  <div className="quiz-header">
    <button 
      className="back-button" 
      onClick={onBack}
      aria-label="Back to quizzes"
      title="Back to quizzes"
    >
      <FaArrowLeft />
    </button>
    
    <h2>{title}</h2>
    
    <div className="quiz-meta">
      <span className="question-count">
        Question {currentQuestionIndex + 1} of {totalQuestions} • <span className="score"><FaTrophy size={15} color="gold" /> Score: {score}</span>
      </span>
    </div>
  </div>
);

QuizHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  currentQuestionIndex: PropTypes.number.isRequired,
  totalQuestions: PropTypes.number.isRequired,
  score: PropTypes.number.isRequired
};

